import request from '@/utils/request'

export function commonAPI(api,postData){
  let token=sessionStorage.getItem("token")
  let Atoken=sessionStorage.getItem("Atoken")
  if(postData===''){
    return request({
      url:'/'+api,
      method:'post',
    })
  }else if(postData==='1'){
	return request({
	  url:'/'+api,
	  method:'get',
	})
  }else{
    return request({
      url:'/'+api,
      method:'post',
      data:postData,
      headers:{
        'token':token,
        'Atoken':Atoken,
      },
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/commonAPI.js